import styled from '@emotion/styled';

const StatusBarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  box-flex-group: border-box;
  width: 100%;
  min-height: 52px;
  padding: 0.25rem 1rem;
  margin-bottom: 1.25rem;
  color: #ffffff;
  /* This is an official work around for centering flex items with "min-height" without a set height 
    obtained from https://github.com/philipwalton/flexbugs/issues/231#issuecomment-362790042
  */
  &:after {
    content: '';
    min-height: inherit;
    font-size: 0;
  }
  & button {
    flex: 0 0 auto;
    margin-left: 1.5rem;
  }
  & > div {
    flex: 0 0 auto;
    margin-left: 1.5rem;
  }
  & svg {
    flex: 0 0 1.5rem;
    height: 24px;
  }
  p {
    font-size: 0.875rem;
    line-height: 1.25em;
    margin: 0;
    font-weight: 600;
    margin-left: 1rem;
  }
`;

export { StatusBarWrapper, StatusBarWrapper as default };
